// extracted by mini-css-extract-plugin
module.exports = {"personalDataWrapper":"StepPersonalData_personalDataWrapper__1loAA","personalDataActions":"StepPersonalData_personalDataActions__275ds","title":"StepPersonalData_title__1EEyv"};